export default __webpack_public_path__ + "static/media/DoneIcon.699a32df.svg";